import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function HowItWorks() {
  const steps = [{
    num: '01',
    text: 'Aplica el Reset Térmico 45 minutos antes de acostarte.'
  }, {
    num: '02',
    text: 'Sigue la inducción respiratoria en la cama para bajar tus pulsaciones.'
  }, {
    num: '03',
    text: 'Si despiertas a mitad de noche, usa el protocolo de re-inducción de 3 pasos.'
  }];
  return <section className="py-24 bg-navy-800 border-y border-navy-700" data-id="element-223">
      <div className="max-w-5xl mx-auto px-6" data-id="element-224">
        <FadeIn data-id="element-225">
          <h2 className="text-3xl md:text-4xl font-serif text-center mb-16" data-id="element-226">
            Cómo funciona en la práctica
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-227">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-[1px] bg-navy-600 z-0" data-id="element-228"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={0.2 + index * 0.1} className="relative z-10" data-id="element-229">
              <div className="flex flex-col items-center text-center" data-id="element-230">
                <div className="w-24 h-24 rounded-full bg-navy-900 border-2 border-gold-500/30 flex items-center justify-center mb-8 box-glow" data-id="element-231">
                  <span className="text-3xl font-serif text-gold-400" data-id="element-232">
                    {step.num}
                  </span>
                </div>
                <p className="text-body-lg text-cream-muted" data-id="element-233">{step.text}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}